import { PermissionMapping } from '@@/lib/permissions';

export type BulkEditPermission = 'writer';

const bulkEditPermissionMapping: PermissionMapping<BulkEditPermission>[] = [
  {
    permissionSetMapping: {
      writer: ['bulk-edit-admin']
    },
    urlSignature: '/agents',
    showInNavbar: true,
    label: 'Agents'
  }
];

export default bulkEditPermissionMapping;
